// src/components/PageContainer.tsx
import React from "react";
import clsx from "clsx";
import { pageContainerClasses } from "../styles/componentClasses";

type PageContainerProps = {
  children: React.ReactNode;
  /** max content width */
  maxWidth?: "full" | "7xl" | "5xl" | "4xl" | "md";
  /** toggle the decorative background */
  withGradient?: boolean;
  /** extra classes on the OUTER <div> (the full-height bg) */
  className?: string;
  /** extra classes on the INNER content wrapper */
  contentClassName?: string;
};

export function PageContainer({
  children,
  maxWidth = "7xl",
  withGradient = true,
  className,
  contentClassName,
}: PageContainerProps) {
  const maxW = maxWidth === "full" ? "max-w-full" : `max-w-${maxWidth}`;

  return (
    <div
      className={clsx(
        pageContainerClasses.outer,
        className
      )}
    >
      <div
        className={clsx(
          pageContainerClasses.innerBase,
          maxW,
          contentClassName
        )}
      >
        {children}
      </div>
    </div>
  );
}
